import { post } from "../../service/api";

const UpdateTransactionBank = async (transactionId, bankCode) => {
  try {
    const response = await post(`/transaction/${transactionId}/updateBank`, {
      bankCode,
    });
    return response;
  } catch (error) {
    console.error("Error UpdateTransactionBank:", error);
    throw error;
  }
};

export default UpdateTransactionBank;
